"use client";

import Description from "@/containers/product/Description";
import Top from "@/containers/product/Top";
import { addToCartAsync, setDraftRequest } from "@/store/features/cartSlice";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { encryptString, toCartAnimation, toLoginPage } from "@/utils";
import { useRouter } from "@/hooks/useCompatRouter";

const ProductView = ({
  product,
  relatedProducts,
}: {
  product: ProductDetails;
  relatedProducts: ProductItemV2[] | null;
}) => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const isLoggedIn = useAppSelector((state) => !!state.auth.access_token);

  const handleAddToCard = (
    sku: ProductDetailsSkus,
    quantity: number,
    extraData: ExtraAddToCartData,
  ) => {
    if (isLoggedIn) {
      dispatch(
        addToCartAsync({
          skuId: sku.id,
          quantity,
          brand_gift: extraData.brand_gift,
          gng_gift: extraData.gng_gift,
          discount: extraData.discount,
          emi: extraData.emi,
        }),
      ).then((args) => {
        if (args.meta.requestStatus === "fulfilled") {
          toCartAnimation();
        }
      });
    } else {
      dispatch(
        setDraftRequest({
          skuId: sku.id,
          quantity,
          brand_gift: extraData.brand_gift,
          gng_gift: extraData.gng_gift,
          discount: extraData.discount,
          emi: extraData.emi,
        }),
      );

      toLoginPage(router);
    }
  };

  const handleBuyNow = (
    sku: ProductDetailsSkus,
    quantity: number,
    extraData: ExtraAddToCartData,
  ) => {
    const path = `/checkout?productId=${product.slug}&skuId=${
      sku.id
    }&quantity=${quantity}&extra=${encryptString(JSON.stringify(extraData))}`;
    if (isLoggedIn) {
      router.push(path);
    } else {
      toLoginPage(router, path);
    }
  };

  return (
    <div key={product.slug} className="bg-primary-white">
      {!product.displayOnly && (
        <Top
          product={product}
          onAddToCart={handleAddToCard}
          onBuyNow={handleBuyNow}
        />
      )}

      <Description product={product} relatedProducts={relatedProducts as any} />
    </div>
  );
};

export default ProductView;
